import { $, $$ } from 'utils/dom';
import Swiperslider from 'modules/swiper/swiper';
class ToggleCenters {
  constructor(props) {
    this.container = props.container;
    this.toggleButtons = $$('.centers__buttons button', this.container);
    this.toggleItems = $$('.centers__toggle-item', this.container);
  }

  handleButtonClick = (button, key) => {
    this.toggleButtons.forEach(button => {
      button.disabled = false;
    });
    button.disabled = true;

    this.toggleItems.forEach((item, index) => {
      if (item.getAttribute('data-id') === button.getAttribute('data-id')) {
        item.classList.toggle('is-active');
      } else if (key !== index) {
        item.classList.remove('is-active');
      }
    });
  };

  bindEvents = () => {
    this.toggleButtons.forEach(button => {
      button.addEventListener(
        'click',
        this.handleButtonClick.bind(this, button)
      );
    });
  };

  init = () => {
    this.bindEvents();
  };
}

class ShowRandomHighlight {
  constructor(props) {
    this.container = props.container;
    this.highlights = $$('.centers__highlight', this.container);
  }

  randomHighlight = () => {
    const randomItem = Math.floor(Math.random() * this.highlights.length);
    this.highlights[randomItem].classList.add('is-active');
  };

  bindEvents = () => {
    this.randomHighlight();
  };

  init = () => {
    this.bindEvents();
  };
}

const centers = $$('.centers');

if (centers.length) {
  centers.forEach(center => {
    new ToggleCenters({
      container: center,
    }).init();
  });

  centers.forEach(center => {
    new ShowRandomHighlight({
      container: center,
    }).init();
  });

  centers.forEach(center => {
    const slider = new Swiperslider($('.centers__item-wrapper', center), {
      container: center,
      sliderOptions: {
        spaceBetween: 15,
        breakpoints: {
          // when window width is >= 768px
          768: {
            spaceBetween: 30,
          },
        },
      },
    });
    slider.init();
  });
}
